import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4017ce58&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4017ce58&scoped=true&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4017ce58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4017ce58')) {
      api.createRecord('4017ce58', component.options)
    } else {
      api.reload('4017ce58', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4017ce58&scoped=true", function () {
      api.rerender('4017ce58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-prop/detail/index.vue"
export default component.exports